var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"crumbs"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_c('i',{staticClass:"el-icon-s-tools"}),_vm._v("商品相关")])],1)],1),_c('div',{staticClass:"container",staticStyle:{"min-width":"900px"}},[_c('div',[_c('ProduceControl')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }